import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header";

import "./styles.css";
import "../../styles/Loader.css";

const UserError = () => {
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);
  return (
    <div>
      <div>
        <Header
          headerHeading="NVIDIA Application Hub"
          loginHeader={true}
          dashboardHeader={false}
        ></Header>
        <div className="centered-message-app">
          <div className="centered-message">
            <p>
              {" "}
              We were unable to verify your account. Please click on {" "}
              <Link className="sign-in-text sign-in-text-medium" to="/needhelp">
                Need help
              </Link>{" "}
              and read the FAQs for additional details in order to take further action.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserError;
